module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 77
// module chunks = 0 1 2 3 4 5 6 7 10 11